import Banner from "./Banner";
import DownloadAppBanner from "./DownloadAppBanner";

interface Props {
  showAppDownload: boolean;
  onOpen: () => void;
  onClose: () => void;
}

const AppBannerContent: React.FC<Props> = ({
  showAppDownload,
  onOpen,
  onClose,
}) => {
  return showAppDownload ? (
    <DownloadAppBanner onClose={onClose} />
  ) : (
    <Banner showAppDownload={onOpen} onClose={onClose} />
  );
};

export default AppBannerContent;
